export const QUANTIVE_REGIONS = [
  {
    name: 'United States',
    value: '.us',
    id: 'us'
  },
  {
    name: 'Europe',
    value: '',
    id: 'default'
  },
  {
    name: 'South America',
    value: '.sa',
    id: 'sa'
  },
  {
    name: 'Asia',
    value: '.as',
    id: 'as'
  }
];

export const NO_SPACE_REGEX = [/^[^ \/]+$/, ''];
export const ROOT_DOMAIN_REGEX = /(^[a-z][a-z0-9+.-]*:\/\/(www\.)?)|(\.[a-z]{2,}$)/gi;

export const FRESHDESK_DEFAULT_HISTORICAL_IMPORT_DAYS = 30;
